
namespace RioERP.Reports {

    @Serenity.Decorators.registerClass()
    export class ShippingReportGrid extends Serenity.EntityGrid<ShippingReportRow, any> {
        protected getColumnsKey() { return ShippingReportColumns.columnsKey; }
        protected getDialogType() { return ShippingReportDialog; }
        protected getIdProperty() { return ShippingReportRow.idProperty; }
        protected getInsertPermission() { return ShippingReportRow.insertPermission; }
        protected getLocalTextPrefix() { return ShippingReportRow.localTextPrefix; }
        protected getService() { return ShippingReportService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}